import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';
import Loader from 'halogen/PulseLoader';
import css from '../index.scss';
import RadioButton from '../../radiobutton/index';
import messages from '../messages';
import Button from '../../button/index';
import { DARK } from '../../button/variants';
import DropDownList from '../../dropdown-list/index';
import listStyle from '../dropdown-list.scss';

const SignInCardsDownloadView = (props) => {
    const { intl,
        teachers,
        onTeacherSelection,
        isClassroomsLoaded,
        isTeachersLoaded,
        currentSelection,
        onChangeCurrentSelection,
        onLabelSelectionChange,
        signInCardsEnum,
        filteredClassrooms,
        onClassSelectionChange,
        disableDownload,
        onDownloadSignInCards,
        isStudentSignInCardDownloaded,
        isTeacherSignInCardDownloaded } = props;

    const cloneAllTeachers = cloneDeep(teachers);
    delete cloneAllTeachers['0'];

    const cloneFilteredClasses = cloneDeep(filteredClassrooms);
    delete cloneFilteredClasses['0'];

    signInCardsEnum.LABELS.SIZES[0].value = `QR ${intl.formatMessage(messages.code)} 3 X 3`;
    signInCardsEnum.LABELS.SIZES[1].value = `QR ${intl.formatMessage(messages.code)} 2 X 2`;
    signInCardsEnum.LABELS.SIZES[2].value = `2 x 5 ${intl.formatMessage(messages.label)}`;
    signInCardsEnum.LABELS.SIZES[3].value = `2 x 7 ${intl.formatMessage(messages.label)}`;
    signInCardsEnum.LABELS.SIZES[4].value = `3 x 8 ${intl.formatMessage(messages.label)}`;

    const finalView = (isClassroomsLoaded && isTeachersLoaded)
        ? (<div className={css.container}>
            <div className={css.header}>
                {intl.formatMessage(messages.signInCards)}
            </div>
            <div className={css.selection}>
                <span className={css.title}>
                    <RadioButton
                        checked={currentSelection === signInCardsEnum.STUDENTS}
                        name="userSelector"
                        onChange={() => { onChangeCurrentSelection(signInCardsEnum.STUDENTS, filteredClassrooms); }} />
                    {intl.formatMessage(messages.students)}
                </span>
                <span className={css.title}>
                    <RadioButton
                        checked={currentSelection === signInCardsEnum.TEACHERS}
                        name="userSelector"
                        onChange={() => { onChangeCurrentSelection(signInCardsEnum.TEACHERS, filteredClassrooms); }} />
                    {intl.formatMessage(messages.teachers)}
                </span>
            </div>
            <div className={css.list}>
                <DropDownList
                    css={listStyle}
                    name="teachers"
                    onChange={onTeacherSelection}
                    options={cloneAllTeachers}
                    placeholder={intl.formatMessage(messages.allTeachers)}
                />
                <DropDownList
                    css={listStyle}
                    disabled={currentSelection === signInCardsEnum.TEACHERS}
                    name="classrooms"
                    onChange={onClassSelectionChange}
                    options={cloneFilteredClasses}
                    placeholder={intl.formatMessage(messages.allClasses)}
                />
                <DropDownList
                    css={listStyle}
                    disabled={currentSelection === signInCardsEnum.TEACHERS}
                    name="labelSizes"
                    onChange={onLabelSelectionChange}
                    options={signInCardsEnum.LABELS.SIZES}
                />
            </div>
            <div className={css.footer}>
                <Button
                    disabled={disableDownload}
                    handleOnClick={onDownloadSignInCards}
                    label={intl.formatMessage(messages.download)}
                    loading={!isStudentSignInCardDownloaded || !isTeacherSignInCardDownloaded}
                    loadingLabel={intl.formatMessage(messages.downloading)}
                    variant={DARK} />
            </div>
        </div>) : (<div className={css.loader}>
            <Loader color="grey" size="15px" />
        </div>);

    return finalView;
};

SignInCardsDownloadView.propTypes = {
    intl: intlShape.isRequired,
    teachers: PropTypes.array,
    labelSize: PropTypes.array,
    filteredClassrooms: PropTypes.array,
    onTeacherSelection: PropTypes.func,
    onClassSelectionChange: PropTypes.func,
    onLabelSelectionChange: PropTypes.func,
    onChangeCurrentSelection: PropTypes.func,
    onDownloadSignInCards: PropTypes.func,
    signInCardsEnum: PropTypes.func,
    isClassroomsLoaded: PropTypes.bool,
    isTeachersLoaded: PropTypes.bool,
    disableDownload: PropTypes.bool,
    isStudentSignInCardDownloaded: PropTypes.bool,
    isTeacherSignInCardDownloaded: PropTypes.bool,
    currentSelection: PropTypes.string
};

export default injectIntl(styleable(css)(SignInCardsDownloadView));




// WEBPACK FOOTER //
// ./app/components/sign-in-cards/pages/sign-in-cards.js